import { createQuery } from "react-query-kit";

import type { IDoctorCostEndpoint } from ".";

import type { AxiosError, IApiResponse, IAxiosFn } from "@/api";
import { axiosClient } from "@/api";
import type { IApptVisitType, ID } from "@/constants";

const key = "doctor-cost";

type IResponse = IApiResponse<IDoctorCostEndpoint>;
export interface IVariables {
  doctorId: ID;
  visitType: IApptVisitType;
  facility_id: ID;
}

const getDoctorCost: IAxiosFn<IVariables, IResponse> = async (
  params,
  signal,
) => {
  const { doctorId, visitType, ...rest } = params;
  const { data } = await axiosClient.get(
    `/appointments/cost/${doctorId}/${visitType}`,
    {
      params: { ...rest },
      signal,
    },
  );

  return data;
};

export const useDoctorCost = createQuery<IResponse, IVariables, AxiosError>({
  primaryKey: key,
  queryFn: ({ queryKey: [_primaryKey, variables], signal }) =>
    getDoctorCost(variables, signal),
});
